/* Home pile toy. Parts fall when the section scrolls into view, then every
   part can be dragged and thrown. A plain click (no drag) on the kit opens it. */
(function () {

  /* Light effects. Coordinates are fractions of the sprite image (measured on the
     renders in assets/pile-*.webp). A part lights only while it is moving (falling,
     thrown, tumbling) or held, and goes dark when it comes to rest. */
  var HOLD = .5; // seconds it stays lit after the last movement, so it does not flicker
  var HEART = ['00000000', '01100110', '11111111', '11111111', '01111110', '00111100', '00011000', '00000000'];
  var DIGITS = ['abcdef', 'bc', 'abdeg', 'abcdg', 'bcfg', 'acdfg', 'acdefg', 'abc', 'abcdefg', 'abcdfg'];
  // centre lines of the seven segments on tk53 (fractions of 490 x 900 px)
  var SEG = {
    a: [190, 125, 372, 125], g: [160, 322, 340, 322], d: [125, 516, 312, 516],
    f: [175, 148, 143, 302], b: [374, 148, 342, 305], e: [140, 345, 118, 495], c: [342, 342, 318, 495]
  };
  var PP = [];
  for (var r = 0; r < 17; r++) PP.push([70 / 750, (224 + 30 * r) / 900]);
  for (r = 0; r < 19; r++) PP.push([672 / 750, (163 + 30 * r) / 900]);

  function hexSeg(ctx, c, W, H, grow) {
    var x1 = c[0] / 490, y1 = c[1] / 900, x2 = c[2] / 490, y2 = c[3] / 900;
    var dx = (x2 - x1) * W, dy = (y2 - y1) * H, L = Math.sqrt(dx * dx + dy * dy), ux = dx / L, uy = dy / L;
    var h = 17 / 490 * W + (grow || 0), nx = -uy, ny = ux, ax = x1 * W, ay = y1 * H, bx = x2 * W, by = y2 * H;
    ctx.beginPath();
    ctx.moveTo(ax - ux * h, ay - uy * h);
    ctx.lineTo(ax + nx * h * .9, ay + ny * h * .9); ctx.lineTo(bx + nx * h * .9, by + ny * h * .9);
    ctx.lineTo(bx + ux * h, by + uy * h);
    ctx.lineTo(bx - nx * h * .9, by - ny * h * .9); ctx.lineTo(ax - nx * h * .9, ay - ny * h * .9);
    ctx.closePath();
  }
  function glow(ctx, x, y, rad, rgb, a) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, rad);
    g.addColorStop(0, 'rgba(' + rgb + ',' + a + ')'); g.addColorStop(1, 'rgba(' + rgb + ',0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, rad, 0, 6.2832); ctx.fill();
  }
  var FX = {
    matrix: function (c, W, H, t) {
      var rad = .046 * W, beat = .8 + .2 * Math.sin(t * 7);
      for (var y = 0; y < 8; y++) for (var x = 0; x < 8; x++) {
        var cx = (.081 + .12 * x) * W, cy = (.064 + .0933 * y) * H, on = HEART[y][x] === '1';
        c.fillStyle = '#2b2b2b'; c.beginPath(); c.arc(cx, cy, rad * 1.04, 0, 6.2832); c.fill();
        if (on) {
          glow(c, cx, cy, rad * 2.1, '255,40,60', .5 * beat);
          c.fillStyle = 'rgb(255,' + Math.round(60 + 40 * beat) + ',' + Math.round(70 + 20 * beat) + ')';
          c.beginPath(); c.arc(cx, cy, rad * .92, 0, 6.2832); c.fill();
        }
      }
    },
    seg: function (c, W, H, t) {
      var d = DIGITS[Math.floor(t * 2.5) % 10];
      c.fillStyle = '#383838';
      for (var k in SEG) { hexSeg(c, SEG[k], W, H, 3); c.fill(); }
      c.beginPath(); c.arc(381 / 490 * W, 516 / 900 * H, 24 / 490 * W, 0, 6.2832); c.fill();
      c.shadowColor = 'rgba(255,50,50,.9)'; c.shadowBlur = W * .05; c.fillStyle = '#ff3b3b';
      for (var i = 0; i < d.length; i++) { hexSeg(c, SEG[d[i]], W, H, -1); c.fill(); }
      c.shadowBlur = 0;
    },
    rgb: function (c, W, H, t) {
      var cols = ['255,40,40', '40,255,70', '60,110,255'], i = Math.floor(t / .5) % 3, ph = (t % .5) / .5, a = Math.sin(Math.min(1, ph) * Math.PI);
      var x = .5 * W, y = .24 * H;
      glow(c, x, y, .2 * W, cols[i], .85 * a);
      c.fillStyle = 'rgba(' + cols[i] + ',' + (.9 * a) + ')';
      c.fillRect(x - .115 * W, y - .085 * H, .23 * W, .17 * H);
    },
    pinpulse: function (c, W, H, t, st) {
      var step = Math.floor(t / .09);
      if (st.step !== step) { st.step = step; st.on = st.on || []; for (var i = 0; i < PP.length; i++) if (st.on[i] === undefined || Math.random() < .3) st.on[i] = Math.random() < .5; }
      var w = .046 * W, h = .017 * H;
      for (var j = 0; j < PP.length; j++) {
        var x = PP[j][0] * W, y = PP[j][1] * H;
        c.fillStyle = '#25282c'; c.fillRect(x - w * .62, y - h * .75, w * 1.24, h * 1.5);
        if (st.on[j]) {
          glow(c, x, y, w * 1.1, '80,255,140', .55);
          c.fillStyle = '#7dffa8'; c.fillRect(x - w * .45, y - h * .5, w * .9, h);
        }
      }
    },
    gold: function (c, W, H, t) {
      var x = .58 * W, y = .572 * H, b = .5 + .5 * Math.sin(t * 2.6 - 1.57), rgb = 'hsl(' + ((t * 90) % 360) + ',100%,60%)';
      var g = c.createRadialGradient(x, y, 0, x, y, .22 * W);
      g.addColorStop(0, 'hsla(' + ((t * 90) % 360) + ',100%,62%,' + (.2 + .75 * b) + ')'); g.addColorStop(1, 'hsla(' + ((t * 90) % 360) + ',100%,62%,0)');
      c.fillStyle = g; c.beginPath(); c.arc(x, y, .22 * W, 0, 6.2832); c.fill();
      c.fillStyle = rgb; c.globalAlpha = .25 + .7 * b; c.fillRect(x - .1 * W, y - .028 * H, .2 * W, .056 * H); c.globalAlpha = 1;
    }
  };

  function init(root) {
    var M = window.Matter;
    if (!M || root.__pile) return;
    root.__pile = 1;
    var stage = root.querySelector('[data-stage]');
    var imgs = [].slice.call(stage.querySelectorAll('.lb-pile__s'));
    var href = root.getAttribute('data-href');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 0, H = 0, k = 1, engine, items = [], walls = [], started = false, running = false, last = 0, acc = 0;
    var drag = null;

    function measure() {
      W = stage.clientWidth; H = stage.clientHeight;
      k = Math.max(0.42, Math.min(1.1, W / 1200));
    }

    function build() {
      measure();
      engine = M.Engine.create({ enableSleeping: true });
      engine.gravity.y = 2.4;
      var T = 600;
      walls = [
        M.Bodies.rectangle(W / 2, H + T / 2, W + 2 * T, T, { isStatic: true }),
        M.Bodies.rectangle(-T / 2, H / 2 - 800, T, H + 2000, { isStatic: true }),
        M.Bodies.rectangle(W + T / 2, H / 2 - 800, T, H + 2000, { isStatic: true }),
        M.Bodies.rectangle(W / 2, -1800, W + 2 * T, T, { isStatic: true })
      ];
      M.Composite.add(engine.world, walls);
      imgs.forEach(function (el, n) {
        var nw = +el.dataset.w, nh = +el.dataset.h, long = +el.dataset.long * k;
        var s = long / Math.max(nw, nh), w = nw * s, h = nh * s;
        el.style.width = w + 'px'; el.style.height = h + 'px';
        var x = w / 2 + Math.random() * Math.max(1, W - w);
        var kit = el.hasAttribute('data-kit');
        var y = -(120 + (kit ? imgs.length : n) * 70 + Math.random() * 80); // the kit falls last, so it lands on top
        var b = M.Bodies.rectangle(x, y, w * 0.94, h * 0.94, {
          chamfer: { radius: Math.min(w, h) * 0.06 },
          restitution: 0.06, friction: 0.7, frictionAir: 0.02, density: 0.006,
          angle: (Math.random() - 0.5) * 1.6, sleepThreshold: 90
        });
        M.Body.setVelocity(b, { x: (Math.random() - 0.5) * 3, y: 0 });
        M.Composite.add(engine.world, b);
        var it = { el: el, b: b, w: w, h: h, kit: kit, fx: el.dataset.fx || '', st: {}, until: 0, t0: 0, drawn: false };
        if (it.fx && FX[it.fx]) {
          var dpr = Math.min(2, window.devicePixelRatio || 1), cv = it.cv || document.createElement('canvas');
          cv.className = 'lb-pile__fx'; cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
          cv.style.width = w + 'px'; cv.style.height = h + 'px';
          if (!cv.parentNode) el.insertAdjacentElement('afterend', cv);
          it.cv = cv; it.ctx = cv.getContext('2d');
        }
        b.__it = it;
        items.push(it);
      });
      root.classList.add('is-ready');
      draw();
    }

    function drag_is(it) { return drag && drag.it === it; }
    function lightUp(it, forever) {
      var now = performance.now() / 1000;
      if (it.until <= now) it.t0 = now;
      it.until = forever ? Infinity : now + HOLD;
    }
    function draw() {
      var now = performance.now() / 1000;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], p = it.b.position;
        if (p.y > H + 300 || p.x < -300 || p.x > W + 300) {
          M.Body.setPosition(it.b, { x: W / 2, y: -150 }); M.Body.setVelocity(it.b, { x: 0, y: 0 });
        }
        var tf = 'translate(' + (p.x - it.w / 2).toFixed(1) + 'px,' + (p.y - it.h / 2).toFixed(1) + 'px) rotate(' + it.b.angle.toFixed(4) + 'rad)';
        it.el.style.transform = tf;
        if (it.cv) {
          it.cv.style.transform = tf;
          if (it.until > now) {
            var c = it.ctx, k = it.cv.width / it.w, left = it.until - now;
            c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, it.cv.width, it.cv.height);
            c.globalAlpha = Math.min(1, left / .25);
            FX[it.fx](c, it.cv.width, it.cv.height, now - it.t0, it.st);
            c.globalAlpha = 1; it.drawn = true;
          } else if (it.drawn) { it.ctx.clearRect(0, 0, it.cv.width, it.cv.height); it.drawn = false; }
        }
      }
    }

    function tick(t) {
      if (!running) return;
      acc += Math.min(50, t - last); last = t;
      while (acc >= 1000 / 60) {
        engine.timing.timestamp += 1000 / 60;
        M.Engine.update(engine, 1000 / 60);
        for (var i = 0; i < items.length; i++) {
          var v = items[i].b.velocity, sp = Math.sqrt(v.x * v.x + v.y * v.y);
          if (items[i].cv && !drag_is(items[i]) && (sp > .6 || Math.abs(items[i].b.angularVelocity) > .012)) lightUp(items[i]);
          if (sp > 32) M.Body.setVelocity(items[i].b, { x: v.x * 32 / sp, y: v.y * 32 / sp });
        }
        acc -= 1000 / 60;
      }
      draw();
      requestAnimationFrame(tick);
    }
    function run(on) {
      if (on && !running) { running = true; last = performance.now(); acc = 0; requestAnimationFrame(tick); }
      else if (!on) running = false;
    }

    function start() {
      if (started) return; started = true;
      build();
      if (reduce) {
        for (var i = 0; i < 420; i++) M.Engine.update(engine, 1000 / 60);
        draw();
      }
      run(true);
      setTimeout(function () { if (!drag && !root.__touched) root.classList.add('is-hint'); }, reduce ? 300 : 2600);
    }

    /* drag + throw */
    function pt(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    stage.addEventListener('pointerdown', function (e) {
      var el = e.target.closest && e.target.closest('.lb-pile__s'); if (!el || !started) return;
      var it = items.filter(function (i) { return i.el === el; })[0]; if (!it) return;
      e.preventDefault();
      var p = pt(e), b = it.b;
      M.Sleeping.set(b, false);
      var dx = p.x - b.position.x, dy = p.y - b.position.y, c = Math.cos(-b.angle), s = Math.sin(-b.angle);
      var con = M.Constraint.create({ pointA: p, bodyB: b, pointB: { x: dx * c - dy * s, y: dx * s + dy * c }, stiffness: 0.2, damping: 0.25, length: 0 });
      M.Composite.add(engine.world, con);
      drag = { it: it, con: con, id: e.pointerId, x0: p.x, y0: p.y, t0: performance.now(), moved: 0 };
      stage.setPointerCapture(e.pointerId);
      it.el.style.zIndex = ++root.__z || (root.__z = 10);
      if (it.cv) lightUp(it, true);
      root.classList.add('is-drag'); root.classList.remove('is-hint'); root.__touched = 1;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var p = pt(e);
      p.x = Math.max(0, Math.min(W, p.x)); p.y = Math.max(-200, Math.min(H, p.y));
      drag.con.pointA = p;
      drag.moved = Math.max(drag.moved, Math.abs(p.x - drag.x0) + Math.abs(p.y - drag.y0));
      M.Sleeping.set(drag.it.b, false);
    });
    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      M.Composite.remove(engine.world, drag.con);
      var it = drag.it, click = drag.moved < 8 && performance.now() - drag.t0 < 400;
      drag = null; root.classList.remove('is-drag');
      if (it.cv) it.until = performance.now() / 1000 + HOLD;
      if (click && it.kit && e.type === 'pointerup' && href) window.location.href = href;
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { start(); run(true); } else run(false);
      });
    }, { threshold: 0.35 });
    io.observe(stage);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!started || Math.abs(stage.clientWidth - W) < 40) return;
        // sizes depend on the stage width: start over, the parts fall again
        if (drag) { drag = null; root.classList.remove('is-drag'); }
        M.Composite.clear(engine.world, false); M.Engine.clear(engine);
        items = [];
        [].slice.call(stage.querySelectorAll('.lb-pile__fx')).forEach(function (n) { n.remove(); });
        build();
      }, 250);
    });
  }

  function boot() { document.querySelectorAll('[data-lb-pile]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
